var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"igi",attrs:{"contenteditable":"false"}},[_c('img',{staticStyle:{"max-height":"200px","display":"block"},attrs:{"src":_vm.node.attrs.src}}),_vm._v(" "),_c('div',{staticClass:"igi__controls"},[_c('v-icon',{attrs:{"color":"white"},on:{"click":_vm.onCloseClick}},[_vm._v("\n      mdi-close\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }